import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Tenant360 from './Tenant360';

/** Route wrapper: /superadmin-portal/dashboard/tenants/:tenantRef/360 */
const TenantThreeSixtyPage = () => {
  const { tenantRef } = useParams();
  const navigate = useNavigate();
  return <Tenant360 tenantRef={tenantRef} onClose={() => navigate('/superadmin-portal/dashboard/tenants')} />;
};

export default TenantThreeSixtyPage;
